import React, { useRef, useEffect } from 'react';
import { useIntl } from 'react-intl';

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=React,g=60103;reactJsxRuntime_production_min.Fragment=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");reactJsxRuntime_production_min.Fragment=h("react.fragment");}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;

{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}

const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;

const AccountCenterReact = React;
const AccountCenter = ({
  appEnvironment,
  widgetEnvironment,
  locale,
  user,
  navigateAs
}) => {
  const inputEl = useRef();
  useEffect(() => {
    if (inputEl.current && typeof inputEl.current.setUser !== "undefined") {
      inputEl.current.widgetConfiguration.environment = widgetEnvironment;
    }
  }, [inputEl.current]);
  const otherProps = {
    authentication: "sg-connect-v2"
  };
  if (user) {
    otherProps.user = JSON.stringify(user);
    delete otherProps.authentication;
  }
  if (navigateAs) {
    otherProps["navigate-as"] = "";
    otherProps["navigate-as-list"] = JSON.stringify(navigateAs);
  }
  return jsx("sgwt-account-center", Object.assign({
    ref: inputEl,
    "available-languages": "fr,en,ru",
    mode: "sg-markets",
    language: locale,
    environment: (appEnvironment === null || appEnvironment === void 0 ? void 0 : appEnvironment.toLocaleLowerCase()) === "prod" || (appEnvironment === null || appEnvironment === void 0 ? void 0 : appEnvironment.toLocaleLowerCase()) === "production" ? "" : appEnvironment
  }, otherProps));
};

class KeyDataModel {
  constructor(parent, propertyName) {
    Object.defineProperty(this, "Value", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "Parent", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "PropertyName", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "ModelStateUpdater", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.Parent = parent;
    this.PropertyName = propertyName;
    this.ModelStateUpdater = void 0;
  }
  getJsonPatch() {
    if (this.Value === void 0 || !this.PropertyName) {
      return void 0;
    }
    let result = {};
    result[this.PropertyName] = this.Value;
    let nextNode = this.Parent;
    while (nextNode != void 0) {
      if (nextNode instanceof ObjectDataModel && nextNode.InputContract.isGroup()) {
        nextNode = nextNode.Parent;
      } else if (nextNode.PropertyName) {
        let parentNodeResult = {};
        parentNodeResult[nextNode.PropertyName] = result;
        result = parentNodeResult;
        nextNode = nextNode.Parent;
      } else {
        nextNode = void 0;
      }
    }
    return result;
  }
}

class ObjectDataModel {
  constructor(inputContract, parent) {
    Object.defineProperty(this, "Fields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "Parent", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "PropertyName", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "InputContract", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.Fields = /* @__PURE__ */ new Map();
    this.Parent = parent;
    this.PropertyName = inputContract.propertyName;
    this.InputContract = inputContract;
    inputContract.properties.forEach((property) => {
      if (!this.Fields.has(property.propertyName)) {
        if (property.isObject() || property.isGroup()) {
          this.Fields.set(property.propertyName, new ObjectDataModel(property, this));
        } else if (property.isArray()) {
          this.Fields.set(property.propertyName, new ArrayDataModel(property, this));
        } else {
          this.Fields.set(property.propertyName, new KeyDataModel(this, property.propertyName));
        }
      }
    });
  }
  getJson() {
    let result = {};
    var fields = this.getFlattenedFields(this.Fields);
    fields.forEach((value, name) => {
      if (value instanceof ObjectDataModel) {
        result[name] = value.getJson();
      } else if (value instanceof ArrayDataModel) {
        result[name] = value.getJson();
      } else if (value.Value) {
        result[name] = value.Value;
      }
    });
    return result;
  }
  getFlattenedFields(inputFields) {
    var fields = /* @__PURE__ */ new Map();
    inputFields.forEach((value, name) => {
      if (value instanceof ObjectDataModel && value.InputContract.isGroup()) {
        value.Fields.forEach((val, nam) => {
          fields.set(nam, val);
        });
      } else {
        fields.set(name, value);
      }
    });
    return fields;
  }
  applyJsonPatch(jsonPatch) {
    Object.entries(jsonPatch).forEach((entry) => {
      var _a;
      if (this.Fields.has(entry[0])) {
        let fieldValue = this.Fields.get(entry[0]);
        if (fieldValue instanceof ObjectDataModel) {
          let subTradeCaptureModel = entry[1];
          if (subTradeCaptureModel) {
            fieldValue.applyJsonPatch(subTradeCaptureModel);
          }
        } else if (fieldValue instanceof KeyDataModel) {
          fieldValue.Value = entry[1];
          (_a = fieldValue.ModelStateUpdater) === null || _a === void 0 ? void 0 : _a.call(fieldValue);
        } else if (fieldValue instanceof ArrayDataModel) {
          let subTradeCaptureModel = entry[1];
          if (subTradeCaptureModel) {
            fieldValue.applyJsonPatch(subTradeCaptureModel);
          }
        }
      }
    });
    this.Fields.forEach((value) => {
      if (value instanceof ObjectDataModel && value.InputContract.isGroup()) {
        value.applyJsonPatch(jsonPatch);
      }
    });
  }
  getRoot() {
    let currentNode = this;
    while (currentNode.Parent) {
      currentNode = currentNode.Parent;
    }
    return currentNode;
  }
}

class ArrayDataModel {
  constructor(inputContract, parent) {
    Object.defineProperty(this, "Value", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "Parent", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "PropertyName", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "ModelStateUpdater", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "InputContract", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.Parent = parent;
    this.PropertyName = inputContract.propertyName;
    this.ModelStateUpdater = void 0;
    this.InputContract = inputContract;
    if (inputContract.arrayItems === void 0) {
      throw new Error("ArrayDataModel cannot be instantiated with an inputContract that doesn't describe arrayItems.");
    }
  }
  applyJsonPatch(jsonPatch) {
    var _a;
    if (this.Value) {
      if (jsonPatch.length < this.Value.length) {
        this.Value.splice(jsonPatch.length - 1, this.Value.length - jsonPatch.length);
      }
    } else {
      this.Value = [];
    }
    jsonPatch.forEach((entry, index) => {
      var _a2;
      if (this.Value && !(this.Value[index] instanceof ObjectDataModel)) {
        this.Value[index] = new ObjectDataModel(this.InputContract.arrayItems, this);
      }
      ((_a2 = this.Value) === null || _a2 === void 0 ? void 0 : _a2[index]).applyJsonPatch(entry);
    });
    (_a = this.ModelStateUpdater) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  getJson() {
    var _a;
    let result = [];
    (_a = this.Value) === null || _a === void 0 ? void 0 : _a.forEach((value, index) => {
      if (value instanceof ObjectDataModel) {
        result[index] = value.getJson();
      } else if (value.Value) {
        result[index] = value.Value;
      }
    });
    return result;
  }
}

class DataContract {
  constructor(bookingContractProperty, propertyName) {
    var _a, _b;
    Object.defineProperty(this, "_type", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "nullable", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "properties", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "propertyName", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "title", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "widgetType", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "arrayItems", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "enumValues", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "rank", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "colNumber", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_isReadOnly", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.propertyName = propertyName;
    this.title = (_a = bookingContractProperty.title) !== null && _a !== void 0 ? _a : propertyName;
    this._isReadOnly = bookingContractProperty.readonly;
    if (bookingContractProperty.rank) {
      this.rank = bookingContractProperty.rank;
    } else {
      this.rank = 9999;
    }
    if (bookingContractProperty.colNumber) {
      this.colNumber = bookingContractProperty.colNumber;
    } else {
      this.colNumber = 3;
    }
    if (Array.isArray(bookingContractProperty.type)) {
      this._type = bookingContractProperty.type[0];
      this.nullable = bookingContractProperty.type[1] == "null";
    } else {
      this._type = bookingContractProperty.type;
      this.nullable = false;
    }
    this.properties = Object.entries((_b = bookingContractProperty.properties) !== null && _b !== void 0 ? _b : []).map((p) => new DataContract(p[1], p[0]));
    if (bookingContractProperty.functionalType && bookingContractProperty.functionalType !== "None" && bookingContractProperty.type !== "array") {
      this.widgetType = bookingContractProperty.functionalType;
    } else {
      this.widgetType = Array.isArray(bookingContractProperty.type) ? bookingContractProperty.type[0] : bookingContractProperty.type;
    }
    if (bookingContractProperty.items) {
      this.arrayItems = new DataContract(bookingContractProperty.items, this.propertyName);
    }
    if (bookingContractProperty.enum) {
      this.enumValues = bookingContractProperty.enum;
    }
  }
  isObject() {
    return this._type == "object";
  }
  isArray() {
    return this._type == "array";
  }
  isScalar() {
    return this._type != "object" && this._type != "array" && this._type != "group";
  }
  isGroup() {
    return this._type == "group";
  }
  getTitle() {
    if (this.propertyName == "TradeInfo") {
      return "Contract";
    } else if (this.propertyName == "TradeDate") {
      return "Trade date";
    } else if (this.propertyName == "BdrMnemonic") {
      return "Mnemonic";
    } else if (this.propertyName == "BdrCode") {
      return "Code";
    } else if (this.propertyName == "BdrInitials") {
      return "Initials";
    } else if (this.propertyName == "RtfeLogin") {
      return "Sesame";
    } else if (this.propertyName == "PopsId") {
      return "POPS";
    } else if (this.propertyName == "CifCode") {
      return "CIF";
    } else if (this.propertyName == "FicliCode") {
      return "FICLI";
    } else if (this.propertyName == "SwiftCode") {
      return "Swift";
    } else if (this.propertyName == "Trader") {
      return "Owner";
    }
    return this.title;
  }
  shouldBeDisplayed() {
    return this.propertyName != "LegalData" && this.propertyName != "AllocationInfo" && this.propertyName != "FixingInfo" && this.propertyName != "InstrumentName" && this.propertyName != "InstrumentContractName" && this.propertyName != "FileAttachments" && this.propertyName != "SalesCredits" && this.propertyName != "FileCode" && this.propertyName != "Gop" && this.propertyName != "ProductReference" && this.propertyName != "InterCompanyMirrorTrader" && this.propertyName != "InterCompanyMirrorPortfolio" && this.propertyName != "Sales" && this.propertyName != "CreationUser" && this.propertyName != "ModifUser" && this.propertyName != "SalesCounterparty" && this.propertyName != "ValueDate" && this.propertyName != "CurrencyRO";
  }
  isReadOnly() {
    if (this._isReadOnly) {
      return this._isReadOnly;
    }
    return this.propertyName == "PeriodNumber";
  }
}

const DynamicScreenContext = React.createContext({
  applyPatch: () => void 0
});

const ScalarComponent = (props) => {
  useIntl();
  const getAsInternalValue = (value) => {
    if (value === void 0) {
      return null;
    }
    if (props.inputContract.widgetType === "Date" && value === "0001-01-01") {
      return null;
    }
    if (props.inputContract.widgetType === "Tenor" && value === "0N") {
      return null;
    }
    return value;
  };
  const [internalValue, setInternalValue] = React.useState(getAsInternalValue(props.objectModel.Value));
  const {
    applyPatch
  } = React.useContext(DynamicScreenContext);
  const updateInternalValue = (value) => {
    if (props.inputContract.widgetType === "number" || props.inputContract.widgetType === "integer") {
      setInternalValue(Number(value));
    } else if (props.inputContract.widgetType === "boolean") {
      setInternalValue(value === "true");
    } else {
      setInternalValue(value);
    }
  };
  const refreshObjectModelValue = () => {
    if (props.objectModel.Value !== internalValue) {
      setInternalValue(getAsInternalValue(props.objectModel.Value));
    }
  };
  useEffect(() => {
    if (props.objectModel.ModelStateUpdater) {
      console.error(`dynamic-screen scalar component: ${props.propertyName} already bound`);
    } else {
      props.objectModel.ModelStateUpdater = () => refreshObjectModelValue();
    }
  }, []);
  const checkIfValueChanged = () => {
    if (props.objectModel.Value !== internalValue) {
      props.objectModel.Value = internalValue;
      const jsonPatchMessage = props.objectModel.getJsonPatch();
      if (jsonPatchMessage) {
        applyPatch(jsonPatchMessage);
      }
    }
  };
  if (props.inputContract.widgetType === "Date") {
    return jsxs(Fragment, {
      children: [props.showLabels && jsx("label", Object.assign({
        className: "text-secondary",
        htmlFor: props.propertyName
      }, {
        children: props.inputContract.getTitle()
      })), !props.showLabels ? jsx(Fragment, {
        children: new Date(internalValue).toLocaleDateString("sv-SE")
      }) : jsx("input", {
        id: props.propertyName,
        type: "date",
        readOnly: props.inputContract.isReadOnly(),
        className: "form-control",
        value: new Date(internalValue).toLocaleDateString("sv-SE"),
        onChange: (e) => updateInternalValue(e.target.value),
        onBlur: (e) => checkIfValueChanged()
      })]
    });
  }
  if (props.inputContract.widgetType === "DateTime") {
    return jsxs(Fragment, {
      children: [props.showLabels && jsx("label", Object.assign({
        className: "text-secondary",
        htmlFor: props.propertyName
      }, {
        children: props.inputContract.getTitle()
      })), !props.showLabels ? jsx(Fragment, {
        children: new Date(internalValue).toLocaleString("sv-SE")
      }) : jsx("input", {
        id: props.propertyName,
        type: "date",
        readOnly: props.inputContract.isReadOnly(),
        className: "form-control",
        value: new Date(internalValue).toLocaleString("sv-SE"),
        onChange: (e) => updateInternalValue(e.target.value),
        onBlur: (e) => checkIfValueChanged()
      })]
    });
  }
  if (props.inputContract.widgetType === "boolean") {
    return jsxs(Fragment, {
      children: [props.showLabels && jsx("label", Object.assign({
        className: "text-secondary",
        htmlFor: props.propertyName
      }, {
        children: props.inputContract.getTitle()
      })), jsx("input", {
        id: props.propertyName,
        type: "checkbox",
        readOnly: props.inputContract.isReadOnly(),
        pattern: "\\d*",
        className: "form-control",
        checked: internalValue,
        onChange: (e) => updateInternalValue(String(e.target.checked)),
        onBlur: (e) => checkIfValueChanged()
      })]
    });
  }
  if (props.inputContract.widgetType === "string" && props.inputContract.enumValues) {
    return jsxs(Fragment, {
      children: [props.showLabels && jsx("label", Object.assign({
        className: "text-secondary",
        htmlFor: props.propertyName
      }, {
        children: props.inputContract.getTitle()
      })), !props.showLabels ? jsx(Fragment, {
        children: internalValue
      }) : jsx("select", Object.assign({
        id: props.propertyName,
        disabled: props.inputContract.isReadOnly(),
        className: "form-control",
        value: internalValue,
        onChange: (e) => updateInternalValue(e.target.value),
        onBlur: (e) => checkIfValueChanged()
      }, {
        children: props.inputContract.enumValues.map((value) => jsx("option", Object.assign({
          value
        }, {
          children: value
        })))
      }))]
    });
  }
  if (props.inputContract.widgetType === "string" || props.inputContract.widgetType === "Currency" || props.inputContract.widgetType === "Tenor" || props.inputContract.widgetType === "TenorBucket" || props.inputContract.widgetType === "BusinessDayConvention" || props.inputContract.widgetType === "BdrParty") {
    return jsxs(Fragment, {
      children: [props.showLabels && jsx("label", Object.assign({
        className: "text-secondary",
        htmlFor: props.propertyName
      }, {
        children: props.inputContract.getTitle()
      })), !props.showLabels ? jsx(Fragment, {
        children: internalValue
      }) : jsx("input", {
        id: props.propertyName,
        type: "text",
        readOnly: props.inputContract.isReadOnly(),
        className: "form-control",
        value: internalValue,
        onChange: (e) => updateInternalValue(e.target.value),
        onBlur: (e) => checkIfValueChanged()
      })]
    });
  }
  if (props.inputContract.widgetType === "number") {
    return jsxs(Fragment, {
      children: [props.showLabels && jsx("label", Object.assign({
        className: "text-secondary",
        htmlFor: props.propertyName
      }, {
        children: props.inputContract.getTitle()
      })), !props.showLabels ? jsx(Fragment, {
        children: internalValue
      }) : jsx("input", {
        id: props.propertyName,
        type: "number",
        readOnly: props.inputContract.isReadOnly(),
        className: "form-control",
        value: internalValue,
        onChange: (e) => updateInternalValue(e.target.value),
        onBlur: (e) => checkIfValueChanged()
      })]
    });
  }
  if (props.inputContract.widgetType === "integer") {
    return jsxs(Fragment, {
      children: [props.showLabels && jsx("label", Object.assign({
        className: "text-secondary",
        htmlFor: props.propertyName
      }, {
        children: props.inputContract.getTitle()
      })), jsx("input", {
        id: props.propertyName,
        type: "number",
        readOnly: props.inputContract.isReadOnly(),
        pattern: "\\d*",
        className: "form-control",
        value: internalValue,
        onChange: (e) => updateInternalValue(e.target.value),
        onBlur: (e) => checkIfValueChanged()
      })]
    });
  }
  return jsxs(Fragment, {
    children: [props.inputContract.title, " unknown widget type", " ", props.inputContract.widgetType]
  });
};
ScalarComponent.defaultProps = {
  showLabels: true
};

const ArrayComponent = ({
  propertyName,
  inputContract,
  nestedLevel,
  arrayModel
}) => {
  var _a;
  const [internalValue, setInternalValue] = React.useState([...(_a = arrayModel.Value) !== null && _a !== void 0 ? _a : []]);
  const refreshArrayModelValue = () => {
    var _a2;
    setInternalValue([...(_a2 = arrayModel.Value) !== null && _a2 !== void 0 ? _a2 : []]);
  };
  useEffect(() => {
    if (arrayModel.ModelStateUpdater) {
      console.error(`dynamic-screen array component: ${propertyName} already bound`);
    }
    arrayModel.ModelStateUpdater = () => refreshArrayModelValue();
  }, []);
  if (inputContract.isArray() && inputContract.arrayItems) {
    return jsx(Fragment, {
      children: jsxs("div", Object.assign({
        className: "d-flex flex-column m-3 border"
      }, {
        children: [jsx("div", Object.assign({
          className: "bg-lvl2 p-1"
        }, {
          children: inputContract.title
        })), jsx("div", Object.assign({
          className: "m-2"
        }, {
          children: jsxs("div", Object.assign({
            className: "container"
          }, {
            children: [inputContract.arrayItems.isObject() && jsx("div", Object.assign({
              className: "row m-1"
            }, {
              children: inputContract.arrayItems.properties.map((p) => jsx("div", Object.assign({
                className: "text-secondary col font-xs"
              }, {
                children: p.title
              }), p.propertyName))
            })), internalValue === null || internalValue === void 0 ? void 0 : internalValue.map((model) => jsx(Fragment, {
              children: model instanceof ObjectDataModel ? jsx("div", Object.assign({
                className: "row m-1"
              }, {
                children: jsx(ObjectComponent, {
                  displayStyle: "inline",
                  nestedLevel: nestedLevel + 1,
                  objectModel: model
                }, inputContract.propertyName)
              })) : jsx("div", Object.assign({
                className: "row m-1"
              }, {
                children: jsx(ScalarComponent, {
                  propertyName: inputContract.propertyName,
                  inputContract: inputContract.arrayItems,
                  objectModel: model
                }, inputContract.propertyName)
              }))
            }))]
          }))
        }))]
      }))
    });
  }
  return jsx(Fragment, {});
};

const ObjectComponent = ({
  nestedLevel,
  objectModel,
  displayStyle
}) => {
  if (displayStyle === "box") {
    return jsxs("div", Object.assign({
      className: `d-flex flex-column m-2 ${nestedLevel === 0 ? "" : "border"}`
    }, {
      children: [nestedLevel > 0 && jsx("div", Object.assign({
        className: "bg-lvl2 p-1"
      }, {
        children: objectModel.InputContract.getTitle()
      })), objectModel.InputContract.properties.filter((property) => property.isGroup() && property.shouldBeDisplayed()).sort((p1, p2) => p1.rank - p2.rank).map((property) => jsx(ObjectComponent, {
        displayStyle: "box",
        nestedLevel: nestedLevel + 1,
        objectModel: objectModel.Fields.get(property.propertyName)
      }, property.propertyName)), jsx("div", Object.assign({
        className: "d-flex flex-row flex-wrap justify-content-begin m-2"
      }, {
        children: objectModel.InputContract.properties.filter((property) => property.isScalar() && property.shouldBeDisplayed()).sort((p1, p2) => p1.rank - p2.rank).map((property) => jsx("div", Object.assign({
          className: `form-group col-md-${property.colNumber}`
        }, {
          children: jsx(ScalarComponent, {
            propertyName: property.propertyName,
            inputContract: property,
            objectModel: objectModel.Fields.get(property.propertyName)
          }, property.propertyName)
        })))
      })), objectModel.InputContract.properties.filter((property) => property.isObject() && property.shouldBeDisplayed()).sort((p1, p2) => p1.rank - p2.rank).map((property) => jsx(ObjectComponent, {
        displayStyle: "box",
        nestedLevel: nestedLevel + 1,
        objectModel: objectModel.Fields.get(property.propertyName)
      }, property.propertyName)), objectModel.InputContract.properties.filter((property) => property.isArray() && property.shouldBeDisplayed()).sort((p1, p2) => p1.rank - p2.rank).map((property) => jsx(ArrayComponent, {
        propertyName: property.propertyName,
        inputContract: property,
        nestedLevel: nestedLevel + 1,
        arrayModel: objectModel.Fields.get(property.propertyName)
      }, property.propertyName))]
    }));
  }
  return jsxs(Fragment, {
    children: [objectModel.InputContract.properties.filter((property) => property.isScalar() && property.shouldBeDisplayed()).map((property) => jsx("div", Object.assign({
      className: "col"
    }, {
      children: jsx(ScalarComponent, {
        showLabels: false,
        propertyName: property.propertyName,
        inputContract: property,
        objectModel: objectModel.Fields.get(property.propertyName)
      }, property.propertyName)
    }))), objectModel.InputContract.properties.filter((property) => property.isObject() && property.shouldBeDisplayed()).map((property) => jsx("div", Object.assign({
      className: "col"
    }, {
      children: jsx(ObjectComponent, {
        displayStyle: "box",
        nestedLevel: nestedLevel + 1,
        objectModel: objectModel.Fields.get(property.propertyName)
      }, property.propertyName)
    }))), objectModel.InputContract.properties.filter((property) => property.isArray() && property.shouldBeDisplayed()).map((property) => jsx("div", Object.assign({
      className: "col"
    }, {
      children: jsx(ArrayComponent, {
        propertyName: property.propertyName,
        inputContract: property,
        nestedLevel: nestedLevel + 1,
        arrayModel: objectModel.Fields.get(property.propertyName)
      }, property.propertyName)
    })))]
  });
};

export { AccountCenter, AccountCenterReact, ArrayComponent, ArrayDataModel, DataContract, DynamicScreenContext, KeyDataModel, ObjectComponent, ObjectDataModel, ScalarComponent };
//# sourceMappingURL=main.es.js.map
